import client from "./client";

const getNotifications = () => client.get("notification/user/get");

export default { getNotifications };
